import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleSectionClick = (sectionId, e) => {
    e.preventDefault();
    
    if (isHomePage) {
      // If on home page, scroll to section immediately
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerHeight = 100; // Account for fixed header
          const elementPosition = element.offsetTop - headerHeight;
          
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
          
          // Update URL without triggering navigation
          window.history.pushState(null, '', `#${sectionId}`);
        }
      }, 100);
    } else {
      // If on other page, navigate to home page with hash
      window.location.href = `/#${sectionId}`;
    }
  };

  const handleHomeClick = (e) => {
    if (isHomePage) {
      // If already on home page, scroll to top
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      // Update URL to remove any hash
      window.history.pushState(null, '', '/');
    }
    // If not on home page, let the Link handle navigation normally
  };

  return (
    <header className="bg-white/95 backdrop-blur-sm shadow-lg sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-3 sm:py-4 flex justify-between items-center text-right">
        <Link to="/" className="group">
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gradient hover:scale-105 transition-transform duration-300">
            מצבעת המומחים
          </h1>
        </Link>
        <nav className="flex space-x-2 sm:space-x-4 lg:space-x-8 rtl:space-x-reverse text-sm sm:text-base lg:text-lg font-medium" role="navigation" aria-label="תפריט ראשי">
          <Link 
            to="/" 
            onClick={handleHomeClick}
            className="text-gray-700 hover:text-amber-600 transition-colors duration-300 relative group whitespace-nowrap px-1 sm:px-2"
            aria-label="עבור לדף הבית"
          >
            דף הבית
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-600 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <button
            onClick={(e) => handleSectionClick('gallery', e)}
            className="text-gray-700 hover:text-amber-600 transition-colors duration-300 relative group whitespace-nowrap px-1 sm:px-2"
            aria-label="עבור לגלריות"
          >
            גלריות
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-600 transition-all duration-300 group-hover:w-full"></span>
          </button>
          <Link
            to="/colors"
            className="text-gray-700 hover:text-amber-600 transition-colors duration-300 relative group whitespace-nowrap px-1 sm:px-2"
            aria-label="עבור לקטלוג צבעים"
          >
            צבעים
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-600 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <button
            onClick={(e) => handleSectionClick('about', e)}
            className="text-gray-700 hover:text-amber-600 transition-colors duration-300 relative group whitespace-nowrap px-1 sm:px-2"
            aria-label="עבור לאודות"
          >
            אודות
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-600 transition-all duration-300 group-hover:w-full"></span>
          </button>
          <button 
            onClick={(e) => handleSectionClick('contact', e)}
            className="text-gray-700 hover:text-amber-600 transition-colors duration-300 relative group whitespace-nowrap px-1 sm:px-2"
            aria-label="עבור לצור קשר"
          >
            צור קשר
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-600 transition-all duration-300 group-hover:w-full"></span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;